import React from 'react';
import { SECTOR_METRIC_LABELS } from '../../util/constants';
import StatusBar from '../graphs/StatusBar';

function Sector({ sectorData }) {
  return (
    <div>
      <h2>{sectorData.sector_name}</h2>
      <ul>
        {sectorData.circuits && sectorData.circuits.map((circuit, idx) => (
          <li key={idx}>
            {circuit.circuit_group.length === 1
              ? `Circuit ${circuit.circuit_group[0]}`
              : `Circuits ${circuit.circuit_group[0]} - ${circuit.circuit_group[circuit.circuit_group.length - 1]}`}
          {circuit.inverters && circuit.inverters.length > 0 && (
            <ul>
              <li>
                Inverters {
                  circuit.inverters
                    .map(inv => Array.isArray(inv) ? inv.join(' - ') : inv)
                    .join(', ')
                }
              </li>
            </ul>
          )}
        </li>
        ))}
      </ul>
      <div>
        {Object.keys(SECTOR_METRIC_LABELS)
          .filter((key) => sectorData.metrics[key] !== '' && sectorData.metrics[key] != null)
          .map((key) => (
            <div className="sectorMetric d-flex flex-row align-items-center gap-2 justify-content-between" key={key}>
              <strong>{SECTOR_METRIC_LABELS[key]}</strong>
              {key === 'of_total' ? (
                <StatusBar value={parseFloat(sectorData.metrics[key])} type="status" />
              ) : (
                sectorData.metrics[key]
              )}
            </div>
          ))
        }
      </div>
    </div>
  );
}

export default Sector;
